"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PersonalInfo = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const info_card_1 = require("./info-card");
const PersonalInfo = ({ account, editDetails, }) => {
    let birthday = account?.birthday;
    if (typeof birthday === 'string' && birthday.trim() === '') {
        birthday = 'No birthday provided';
    }
    else if (typeof birthday === 'string' && birthday.trim() !== '') {
        birthday = birthday?.split('-')?.slice(1, 3)?.join('-');
    }
    else if (birthday instanceof Date) {
        birthday =
            ('0' + (birthday.getMonth() + 1)).slice(-2) +
                '-' +
                ('0' + birthday.getDate()).slice(-2);
    }
    else {
        birthday = birthday?.toLocaleString() ?? 'No birthday provided';
    }
    const formatPhoneNumber = (phoneNumber) => {
        return phoneNumber.includes('-')
            ? phoneNumber
            : phoneNumber.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
    };
    const phoneNumber = account?.phoneNumber && formatPhoneNumber(account?.phoneNumber);
    const personalInformationFields = [
        {
            label: 'Name',
            value: (`${account?.firstName}` + ' ' + `${account?.lastName}`),
        },
        {
            label: 'Email',
            value: account?.email,
        },
        {
            label: 'Birthday',
            value: birthday,
        },
        {
            label: 'Phone Number',
            value: phoneNumber ?? '',
        },
    ];
    return ((0, jsx_runtime_1.jsx)(info_card_1.default, { title: 'My Info', infoFields: personalInformationFields, editProps: editDetails }));
};
exports.PersonalInfo = PersonalInfo;
